import { useScreenType } from '@/hooks/media';
import { Button, Image } from '@bfe/moly';
import cls from 'classnames';
import { activityInfo } from '@/types';
import { useFm, useParams } from '@web3/base-hooks';
import {
  formatDateTime,
  replaceBybitToLocationHost,
  appPath,
} from '@web3/base-utils';
import { Page } from '@/config/track-config';
import classNames from 'classnames';

import styles from './index.module.scss';

const iconTask = `${appPath}/images/home/icon-task.svg`;
const iconPartic = `${appPath}/images/home/icon-partic.svg`;
const iconDefault = `${appPath}/images/home/icon-default.svg`;
const cardBg1 = `${appPath}/images/home/feature-card-bg1.svg`;
const cardBg2 = `${appPath}/images/home/feature-card-bg2.svg`;
const cardBg3 = `${appPath}/images/home/feature-card-bg3.svg`;

type IHotActivityCard = {
  data: activityInfo;
  tab: string;
  index?: number;
};

export function HotActivityCard(props: IHotActivityCard) {
  const { isMobile } = useScreenType();
  const { locale } = useParams();
  const { data, tab, index = 0 } = props;
  const fm = useFm();

  const onActivityClick = () => {
    window.location.href = `/${locale}${appPath}/activity?activityId=${data.activityId}&activityTag=${data.activityTag}`;
  };
  return (
    <div
      className={cls([
        'hot-activity-item text-white cursor-pointer',
        tab === 'featured' ? 'hot-activity-featured' : 'hot-activity-ended',
        isMobile
          ? 'hot-activity-item-h5 w-full h-[197px] mb-4'
          : 'w-[500px] h-[268px]',
        styles.container,
      ])}
      onClick={onActivityClick}
      data-spm-even="Web3UserClick"
      data-spm-data={JSON.stringify({
        page_name: Page.AirdropArcadeHome,
        button_name: tab === 'featured' ? 'FeaturedEvent' : 'EndedEvent',
        activity_index: data.activityId,
      })}
    >
      {tab === 'featured' && (
        <div className="card-bg">
          <img
            src={
              index % 3 === 0 ? cardBg1 : index % 3 === 1 ? cardBg2 : cardBg3
            }
            alt=""
          />
        </div>
      )}
      <div
        className={cls([
          'absolute z-{5} w-full h-full left-0 top-0 flex flex-col justify-between',
          isMobile ? ' p-4' : 'p-6',
        ])}
      >
        <div className="w-full">
          {data.rewardDesc && (
            <div className="flex gap-4 rewards mb-4">
              <Button
                variant="secondary"
                size="xx-small"
                className={classNames([
                  `${isMobile ? `!text-xs !min-w-auto !width-auto` : '!h-8'}`,
                  'text-static-black !hover:text-black',
                  styles.desc,
                ])}
                style={{
                  background:
                    'var(--Gradient-Reddish, linear-gradient(90deg, #F90 0%, #FF6A59 100%))',
                }}
              >
                {data.rewardDesc}
              </Button>
            </div>
          )}
          <div className="flex justify-between w-full gap-2 !md:gap-12">
            <div>
              <h3 className="text-xl !md:text-2xl font-semibold mb-2 line-clamp-2">
                {data.activityName}
              </h3>
              <p className="text-xs !md:text-base line-clamp-2">
                {data.activityDesc}
              </p>
              {data.activityStatus === 3 && (
                <p className="text-[10px] !md:text-sm font-light mt-1">
                  {formatDateTime(data.startTime, 'HH:mm', '/')} UTC-
                  {formatDateTime(data.endTime, 'HH:mm', '/')} UTC
                </p>
              )}
            </div>
            <Image
              className="w-14 !md:w-20 h-14 !md:h-20 rounded-full flex-shrink-0"
              src={replaceBybitToLocationHost(data.bizIconUrl) || iconDefault}
              alt=""
            ></Image>
          </div>
        </div>

        <div className="flex justify-between items-center w-full gap-4">
          <div className="flex gap-3">
            <span className="flex items-center gap-1 text-[10px] !md:text-sm">
              <img
                className="w-4 !md:w-6 h-4 !md:h-6"
                src={iconPartic}
                alt=""
              />
              {fm('amountParticipants', {
                amount: data.participants,
              })}
            </span>
            <span className="flex items-center gap-1 text-[10px] !md:text-sm">
              <img className="w-4 !md:w-6 h-4 !md:h-6" src={iconTask} alt="" />
              {fm('amountTasksAvailable', {
                amount: data.taskCnt,
              })}
            </span>
          </div>
          {data.activityStatus === 3 ? (
            ''
          ) : (
            <>
              <Button
                variant={data.activityStatus === 2 ? 'primary' : 'secondary'}
                className={cls(
                  isMobile &&
                    '!h-[36px] !px-[10px] !py-[5px] !min-w-min w-[100px]'
                )}
              >
                {data.activityStatus === 2 ? (
                  <>{fm('start_now')}</>
                ) : (
                  <>{fm('status_upcoming')}</>
                )}
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
